import API from 'api/clients'
import { all, fork } from 'redux-saga/effects'

import UserSaga from './UserSaga'

export default function* accountSagas() {
  yield all([fork(new UserSaga(API).supervise)])
}
